<section class="rcx-table">
    <div class="row">
      <div class="col-lg-12">
        <div class="card btr">
          <div class="card-content">
            <div class="card-body table-responsive">
              <div class="row d-flex justify-content-between align-items-center">
                <div class="col-lg-auto">
                  <h5 class="card-title m-0">
                    <i class="ri-folder-settings-line me-1 text-primary"></i>Projects
                  </h5>
                </div>
                <div class="col-sm-12 col-md-5 col-lg-3 me-auto">
                  <div class="input-group">
                    <span class="input-group-text bg-primary" id="search" ngbTooltip="Search projects by name."
                      placement="top" container="body">
                      <i class="bx bx-search-alt"></i>
                    </span>
                    <input type="text" class="form-control border-start-0" id="search" placeholder="Search..."
                      autocomplete="off" [(ngModel)]="searchKeyword">
                  </div>
                </div>
                <div class="col-sm-12 col-md-auto">
                  <button type="button" class="btn btn-secondary" (click)="upsertProject()" id="add-btn"
                    [ngClass]="{'not-allowed':!privilege.canEdit}"
                    [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): project-pilot.project.edit' : ''">
                    <i class="bx bx-plus"></i> Add Project
                  </button>
                </div>
              </div>
              <table class="table" id="table">
                <thead id="table-thead">
                  <tr class="bg-light">
                    <th scope="col" width="70">#</th>
                    <th scope="col" width="300">Name</th>
                    <th scope="col" width="300">Code</th>
                    <th scope="col" width="500">Status</th>
                    <th scope="col" width="500">Priority</th>
                    <th scope="col" width="160" class="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let project of tableData.content| search : 'name' : searchKeyword; let i=index">
                    <td>{{i+1}}.</td>
                    <td>{{project.name}}</td>
                    <td>{{project.code}}</td>
                    <td class="project-desc">
                      <span [ngClass]="getBadgeClassForStatus(project.status)">
                        {{ formatStatus(project.status) }}
                      </span>
                    </td>
                    <td class="project-desc">
                      <span [ngClass]="getBadgeClassForPriority(project.priority)">
                        {{ formatPriority(project.priority) }}
                      </span>
                    </td>
                    <td class="actions">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" [id]="i" [checked]="project.disabled"
                          [ngClass]="{'no-event':project?.isDeleteInProgress,'not-allowed':!privilege.canEdit}"
                          [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): project-pilot.project.edit' :project.disabled ? 'Mark ' + project.name + ' as enabled.' : 'Mark ' + project.name + ' as disabled.'"
                          placement="top" container="body" [(ngModel)]="project.disabled" (change)="toggleProjectStatus(project)">
                        <label class="form-check-label" [for]="i"></label>
                      </div>
                      <i class="bx bx-edit alert-primary" id="edit-btn"
                        [ngClass]="{'no-event':project?.isDeleteInProgress,'not-allowed':!privilege.canEdit}"
                        [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): project-pilot.project.edit' : 'Update project'"
                        (click)="upsertProject(project)"></i>
                      <i *ngIf="!project?.isDeleteInProgress" class="bx bx-trash alert-secondary" id="update-btn"
                        [ngClass]="{'not-allowed':!privilege.canDelete}"
                        [ngbTooltip]="!privilege.canDelete ? 'You need permissions for this action. Required permission(s): project-pilot.project.delete' : 'Delete project'"
                        (click)="deleteProject(project,i)"></i>
                      <div *ngIf="project?.isDeleteInProgress" role="status"
                        class="spinner-border spinner-border-sm text-danger">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    </td>
                  </tr>
                  <tr class="no-data">
                    <ng-container *ngIf="isLoading; else noDataTemplate">
                      <td colspan="6">Fetching data, please wait...</td>
                    </ng-container>
                    <ng-template #noDataTemplate>
                      <ng-container *ngIf="tableData.content && tableData.content.length < 1; else noSearchResults">
                        <td colspan="6">No projects were found for the search results.</td>
                      </ng-container>
                      <ng-template #noSearchResults>
                        <td colspan="6"  *ngIf="searchKeyword && (tableData.content | search : 'name' : searchKeyword).length == 0">
                          No projects were found for the search results.
                        </td>
                      </ng-template>
                    </ng-template>
                  </tr>
                </tbody>
              </table>
              <div class="row justify-content-between align-items-center pt-3">
                <div class="col-lg-auto">
                  <div class="pagination-entries" id="tickets-table_length">
                    <label class="d-flex align-items-center m-0">
                      <span>Items per page</span>
                      <select name="tickets-table_length" aria-controls="tickets-table"
                        [(ngModel)]="tableData.size" (change)="loadTableData(null)"
                        class="custom-select custom-select-sm form-control form-control-sm mx-2">
                        <option *ngFor="let page of pageSizes" [value]="page">{{page}}</option>
                      </select>
                    </label>
                  </div>                
                </div>
                <div *ngIf="tableData?.content?.length>0" class="col-lg-auto">
                  <ngb-pagination [collectionSize]="tableData.totalElements" [(page)]="tableData.number"
                  [pageSize]="tableData.size" (pageChange)="onPageChange($event)">
                </ngb-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>